import GlobalPlan from "../../components/GlobalPlan";
import HeaderWebsite from "../../components/HeaderWebsite";
import HeaderAccountFree from "../../components/HeaderAccountFree";
export default function PageGlobalPlan(props) {
  const {
      statusMode,
        setStatusMode,
        isLoggedIn,
        showLogoutButton,
        notificationVolume,
        setNotificationVolume,
        userData,
        headerPaid,
  } = props;
  return (<>
  {
headerPaid ?
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      :
       <HeaderAccountFree statusMode={statusMode} />
      }
  <GlobalPlan />
  </>
);
}
